var React = require('react');

function DeleteNarrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"#000","key":0}),React.createElement("g",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M0.25 0.25L6 6","transform":"translate(5 5)","key":0}),React.createElement("path",{"d":"M0.25 0.25L6 6","transform":"translate(5 5) matrix(-1 0 0 1 6 0)","key":1})])]));
}

DeleteNarrowInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = DeleteNarrowInline;

DeleteNarrowInline.default = DeleteNarrowInline;
